import { Component } from "react";
import PropTypes from "prop-types";
import ListingContent from "app/pages/Listing/ListingContent/ListingContent";
import { connect } from "react-redux";
import { getListingItems, isAnyListingFilterActive } from "app/pages/Listing/productsSelector";
import { LISTING_ITEM_TYPES } from "app/constants";

class ListingContentContainer extends Component {
	render() {
		return <ListingContent {...this.props} />;
	}
}

ListingContentContainer.propTypes = {
	spotlightUri: PropTypes.string,
};

const mapStateToProps = (state, props) => {
	const orderedListingItems = getListingItems(props.spotlightUri)(state);
	const merchsListingItems = orderedListingItems.filter(item =>
		[LISTING_ITEM_TYPES.MERCH_SIMPLE, LISTING_ITEM_TYPES.MERCH_CAROUSSEL].includes(item.type)
	);
	return {
		isAnyListingFilterActive: isAnyListingFilterActive(state),
		orderedListingItems: orderedListingItems,
		merchsListingItems: merchsListingItems,
		resolution: state.resolution,
	};
};

export default connect(mapStateToProps)(ListingContentContainer);
